// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"overlay_Overlay__MCglq","Backdrop":"overlay_Backdrop__v8Il1"};